import React, { useState } from "react";

type CheckboxProps = {
    onChange: (isChecked: boolean) => void,
    defaultChecked?: boolean | null,
    disabled?: boolean | null
}

const Checkbox = (props: CheckboxProps) => {
    const { onChange, defaultChecked = false, disabled = false } = props;
    const [checked, setChecked] = useState<boolean | null>(null);

    const unCheckedClassName = !disabled ? "checkbox" : "checkbox disabled";
    const checkedClassName = `${unCheckedClassName} icon-tick`;

    if (checked === null || defaultChecked !== checked) {
        setChecked(defaultChecked);
    }

    const change = (e: any) => {
        e.preventDefault();

        if (disabled) {
            return;
        }

        const isChecked = !checked;
        setChecked(isChecked);
        onChange(isChecked);
    }

    return (
        <span>
            <i className={checked ? checkedClassName : unCheckedClassName} onClick={change}></i>
        </span>
    );
}

export default Checkbox;
